module.exports = __webpack_public_path__ + "img/healthy_page01_left.456a2fe9.gif";